import { Pipe, PipeTransform } from '@angular/core';
import { MainFilterItem } from '../models/mainFilterItem';
import { GridHeader } from '../models/gridHeader';
import { RankingsService } from '../../../../services/rankings.service';

@Pipe({
  name: 'rankingsLabelParse',
  pure: false
})
export class RankingsLabelParser implements PipeTransform {
  constructor(private _rankingsService: RankingsService) {}

  transform(
    input: string,
    selectedGroup: string,
    mainFilterItems: MainFilterItem[],
    reportKey: string
  ): string {
    const foundFilter = this._rankingsService.getFilterSelected(
      mainFilterItems,
      'key',
      'platformName'
    );
    const foundRFilter = this._rankingsService.getFilterSelected(
      mainFilterItems,
      'label',
      'Region'
    );
    const foundCFilter = this._rankingsService.getFilterSelected(
      mainFilterItems,
      'label',
      'Country'
    );
    const foundDFilter = this._rankingsService.getFilterSelected(
      mainFilterItems,
      'key',
      'date'
    );

    const propMap: any = {
      type: selectedGroup,
      platformName: foundFilter.value || '',
      countryCode: foundCFilter.label || '',
      date: foundDFilter.label || ''
    };

    if (
      reportKey === 'publisher-coppa' &&
      propMap.countryCode === 'All Countries'
    ) {
      return 'Popular Apps';
    }

    return this._rankingsService.synthesizeTextByTypeAndFilters(input, propMap);
  }
}
